<template>
  <InteractionStep
                   :disabled-next="false"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-text">
        <h3 class="step-text__title">{{ $tInteraction('Download the PDF file') }}</h3>
        <a :href="downloadLink"
           download

           @click.prevent="onDownload()"
           class="base-btn  base-btn--outline-dark"
        >
          <span class="_one">{{ $tInteraction('Download') }}</span>
          <BaseSvg name="ico-download-2"
                   width="1.4rem"
                   height="1.4rem"/>
        </a>
      </div>
      <BaseAlert :value="error" class="step-contract__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '../../../axios'
  import download from "../../../helpers/download"
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"


  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
      }
    },
    components: {
      InteractionStep
    },
    computed: {
      downloadLink() {
        return `https://api.jobian.com/api/new-interaction/ainfo/pdf/${this.$route.params.id}`
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
      onDownload() {
        download(this.downloadLink, 'visa-info', 'pdf', true)
      }
    }
  }
</script>

<style lang="less">

</style>
